"use client";

import GoogleConnectLink from "@/components/GoogleConnectLink";
import type { Settings } from "@/lib/settings-api";

interface Props {
  settings: Settings | null;
  onUpdate: (s: Settings) => void;
}

export default function GoogleSection({ settings }: Props) {
  const connected = settings?.google_connected || false;

  return (
    <div className="bg-card rounded-2xl border border-border shadow-sm p-4" data-testid="settings-google-section">
      <h2 className="text-sm font-semibold text-text-light mb-1">Google Integration</h2>
      <p className="text-[10px] text-muted mb-3">
        Connect Google so DecisionEase can read busy slots, sync your timetable, and access Drive files
      </p>

      {connected ? (
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-accent/15 flex items-center justify-center">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="stroke-accent" strokeWidth="2">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-medium text-text-light">Connected</p>
              <p className="text-[10px] text-muted">Calendar sync + Drive</p>
            </div>
          </div>
          <span className="text-[10px] text-muted">Manage in Google Account</span>
        </div>
      ) : (
        <GoogleConnectLink
          data-testid="settings-google-connect"
          className="flex items-center justify-center gap-2 w-full py-2.5 px-4 rounded-xl border border-border
                     hover:bg-bg transition-colors text-sm font-medium text-text-light"
        >
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
              fill="#4285F4"
            />
            <path
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              fill="#34A853"
            />
            <path
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              fill="#FBBC05"
            />
            <path
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              fill="#EA4335"
            />
          </svg>
          Connect Google
        </GoogleConnectLink>
      )}
    </div>
  );
}
